
import React from 'react';
import { AsteroidsGameEngine } from './AsteroidsGameEngine';
import MobileTouchControls, { TouchControlAction } from '../common/MobileTouchControls';

interface AsteroidsTouchControlsProps {
  engine: AsteroidsGameEngine | null;
}

const AsteroidsTouchControls: React.FC<AsteroidsTouchControlsProps> = ({ engine }) => {
  if (!engine) return null;

  const handleButtonPress = (action: TouchControlAction) => {
    switch (action) {
      case 'left':
        engine.rotateShipLeft();
        break;
      case 'right':
        engine.rotateShipRight();
        break;
      case 'up':
        engine.startMoving();
        break;
      case 'fire':
        engine.fireBullet();
        break;
      default:
        break;
    }
  };
  
  const handleButtonRelease = (action: TouchControlAction) => {
    switch (action) {
      case 'left':
      case 'right':
        engine.stopRotation();
        break;
      case 'up':
        engine.stopMoving();
        break;
      default:
        break;
    }
  };

  return (
    <MobileTouchControls
      type="directional"
      onButtonPress={handleButtonPress}
      onButtonRelease={handleButtonRelease}
    />
  );
};

export default AsteroidsTouchControls;
